<template>
	<div
		class="ms-combobox flex ms-editor relative"
		:class="[
			{ isValid: errorProvider.isValid, disabled: disabled },
			styleCombo,
		]"
	>
		<input
			ref="input"
			class="input"
			:placeholder="placeholder"
			v-model="internalText"
			v-on="listeners"
			:disabled="disabled"
			:maxlength="maxLength"
			:class="{ disabled: disabled }"
			:readonly="readonly"
		/>
		<div
			class="icon-input"
			v-tooltip="{
				content: errorProvider.message,
				show: focused,
				classes: `error`,
			}"
			v-if="errorProvider.isValid"
		>
			<div class="mi mi-24 mi-red-tick mr-2"></div>
		</div>
		<div
			@click="expand(!expanded)"
			class="icon-combo--dropdown"
			:class="{ disabled: disabled }"
		>
			<div :class="['mi-new-v2 mi-16 mi-icon-v2-arrow-dropdown']"></div>
		</div>
		<ms-combo-box-dropdown
			ref="dropdownPanel"
			v-if="expanded"
			:topx="dropdownTopx"
			:leftx="dropdownLeftx"
			:maxWidthx="dropdownMaxWidthx"
			:minWidthx="dropdownMinWidthx"
			:columnx="columns"
			:comboType="comboType"
			:emptyText="null"
			:isEmptyDataSearch="
				!internalDataSourceFilter || internalDataSourceFilter.length <= 0
			"
			:class="[{ 'combobox-dropdown-custom': isCustomComboxOrg }]"
		>
			<MsRecycleScroller
				ref="scroller"
				:style="styleScroller"
				:items="internalDataSourceFilter"
				:itemSize="itemSize"
				:keyField="keyField"
				:emitUpdate="true"
				:buffer="0"
				:visiableIndex="typeAheadPointer"
				@visible="onScrollerVisible"
				@update="onScrollerUpdate"
				:isCustomComboxOrg="isCustomComboxOrg"
				:itemSizeCustom="45"
			>
				<template v-slot="{ item, index }">
					<ms-combo-box-item
						:comboType="comboType"
						:item="item"
						:columnx="columns"
						:valueField="valueField"
						:displayField="displayField"
						:class="[
							{
								'ms-combobox-item--highlight': typeAheadPointer == index,
							},
							{ 'ms-combobox-item-custom': isCustomComboxOrg },
						]"
						@click.stop="onItemClick(item, $event)"
						:align="alignCombobox"
						:isCustomComboxOrg="isCustomComboxOrg"
						:indexItem="index"
					></ms-combo-box-item>
				</template>
			</MsRecycleScroller>
		</ms-combo-box-dropdown>
	</div>
</template>
<script>
import MsComboBoxDropdown from './MsComboBoxDropdown.vue';
import MsComboBoxItem from './MsComboBoxItem.vue';
import MsRecycleScroller from '@/components/msvirtualscroller/MsRecycleScroller';
import commonFunc from '@/common/commonFunction.js';
import msBaseComponent from '@/components/msbase/msBaseComponent.vue';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';

export default {
	name: 'msAutoComboboxComplete',
	extends: msBaseComponent,
	components: { MsComboBoxDropdown, MsRecycleScroller, MsComboBoxItem },
	inheritAttrs: false,
	props: {
		value: {},
		placeholder: {
			default: null,
			type: [Number, String],
		},
		maxItemsDisplay: {
			default: 5,
			type: Number,
		},
		columns: {
			type: Array,
			default: () => [],
		},
		/**
		 * Trường làm value
		 * CreatedBy LTDAT 15.06.2020
		 */
		valueField: {
			type: String,
			default: null,
		},
		/**
		 * Trường làm text display
		 * CreatedBy LTDAT 15.06.2020
		 */
		displayField: {
			type: String,
			default: null,
		},
		//Dữ liệu của combobox
		data: {
			default: () => [],
			type: Array,
		},
		// //Độ rộng của 1 item
		itemSizeP: {
			default: 36,
			type: Number,
		},
		//Chỉ nhận giá trị có trong danh sách
		forceSelection: {
			default: true,
			type: Boolean,
		},
		//Là combotree hay không
		isComboTree: {
			default: false,
			type: Boolean,
		},
		//Parent Field
		idProperty: {
			default: null,
			type: String,
		},
		//Field chứa parentID
		parentIdProperty: {
			default: 'ParentID',
			type: String,
		},
		//Không cho phép chọn trường là cha
		notSelectionParent: {
			default: false,
			type: Boolean,
		},
		//Độ rông của dropdown tính bằng px
		dropdownWidth: {
			default: null,
			type: [String, Number],
		},
		//Store xử lý dữ liệu trên liên quan đến data trong grid
		store: {
			default: null,
		},
		//Mode query lấy dữ liệu từ server hay client
		queryMode: {
			type: String,
			default: 'remote',
		},
		remoteFilter: {
			type: Boolean,
			default: false,
		},
		//Gán giá trị text lúc ban đầu
		initText: {
			default: null,
			type: [Number, String],
		},
		//Trạng thái có phân trang hay không
		pagination: {
			default: false,
			type: Boolean,
		},
		//Combo mặc định chọn bản ghi theo index
		initIndex: {
			default: -1,
			type: Number,
		},
		disabled: {
			default: false,
			type: Boolean,
		},
		autoLoad: {
			default: false,
			type: Boolean,
		},
		display: {},
		//Tổng số bản ghi
		pageTotal: {
			default: 0,
			type: Number,
		},
		mappingField: {
			default: null,
		},
		firstExpandLoad: {
			default: false,
			type: Boolean,
		},
		keyField: {
			default: '__vKeyValue',
			type: String,
		},
		maxLength: {
			default: null,
			type: Number,
		},
		readonly: {
			default: false,
			type: Boolean,
		},
		// cho phếp bổ sung class để style lại combo
		// Sử dụng cho TH style đặc biệt
		styleCombo: {
			default: '',
			type: String,
		},
		alignCombobox: {
			default: 'left',
			type: String,
		},
		autoMappingValue: {
			default: false,
			type: Boolean,
		},
		//Custom lại combobox cho chi nhánh hình cây
		isCustomComboxOrg: {
			type: Boolean,
			default: false,
		},
		// Không cho phép set dữ liệu item click hay không
		// Phục vụ daterange dashboard
		unAllowSetItemClick: {
			type: Boolean,
			default: false,
		},
		// Load toàn bộ dữ liệu
		isLoadAllData: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		listeners() {
			const me = this;
			return {
				input: (event) => me.onInput(event),
				focus: (event) => me.onFocus(event),
				change: (event) => me.onChange(event),
				blur: (event) => me.onBlur(event),
				keydown: (event) => me.onKeydown(event),
			};
		},
		itemSize() {
			return this.itemSizeP;
		},
		//Tính độ rộng của dropdown combobox để scroll
		styleScroller() {
			const me = this;
			return { 'max-height': me.maxItemsDisplay * me.itemSize + 'px' };
		},
	},
	data() {
		const me = this;
		me.initStaticData();
		return {
			internalDataSource: [],
			internalText: null,
			expanded: false,
			dropdownTopx: 0,
			dropdownLeftx: 0,
			internalSelectedItem: null,
			internalSelectedItemBefore: null,
			typeAheadPointer: -1,
			focused: false,
			internalDataSourceFilter: [],
		};
	},

	//Hàm khởi tạo dữ liệu hook func
	async created() {
		const me = this;
		me.initCombo();
		me.setInitIndex();
		me.initData();

		if (me.autoLoad) {
			me.doQueryInternal(null, false);
		}

		if (me.mappingField) {
			for (let key in me.mappingField) {
				me.$options.propsData[key] = null;
			}
		}
		EventBusGlobal.$on(GlobalEventName.scrollEvent, me.scrollEvent);
	},
	beforeDestroy() {
		const me = this;
		me.expand(false);
		if (me.$refs.dropdownPanel) {
			me.$refs.dropdownPanel.$el.remove();
		}
		document.removeEventListener('mousedown', me.click_out);
		EventBusGlobal.$off(GlobalEventName.scrollEvent, me.scrollEvent);
	},
	mounted() {
		const me = this;
		//Debounce query để delay load
		if (me.queryMode != 'remote') {
			me.internalQueryDelay = 20;
		}
		me.doQuery = _.debounce(me.doQueryInternal, me.internalQueryDelay);
		if (me.store) {
			me.store.pageAppend = true;
		}
	},
	methods: {
		/**
		 * Bắt sự kiện khi scroll trên chương trình thì đóng combobox lại
		 * Created by LTDAT
		 */
		scrollEvent(e) {
			const me = this;
			if (me.expanded) {
				this.expand(false);
			}
		},
		/**
		 * Mặc định chọn giá trị theo index ban đầu
		 * Created by LTDAT
		 */
		setInitIndex() {
			const me = this;
			if (
				me.initIndex >= 0 &&
				me.internalDataSource &&
				me.internalDataSource.length > 0 &&
				me.typeAheadPointer < 0
			) {
				me.typeAheadPointer = me.initIndex;
				me.setInternalItem(me.internalDataSource[me.typeAheadPointer], false);
			}
		},
		/**
		 * Kiểm tra scroll đã đến bản ghi cuối cùng hay chưa
		 * Nếu load theo kiểu phân trang và số bản ghi trong combo nhỏ hơn tổng số bản ghi thi load tiếp dữ liệu vào store
		 * @param start: vị trí bắt đầu của view trong vitual scroll
		 * @param end: vị trí kết thúc của view trong vitual scroll
		 * Created by LTDAT(30.06.2020)
		 *  */
		onScrollerUpdate(start, end) {
			const me = this;
			if (me.pagination) {
				if (
					end == me.internalDataSource.length &&
					end < me.pageTotal &&
					start == me.internalDataSource.length - 5
				) {
					let payload = {
						Skip: me.internalDataSource.length,
						Take: me.internalDataSource.length + 20,
						pageAppend: true,
					};
					me.$emit('loadData', payload);
				}
			}
		},
		/**
		 * Set giá trị hiện thị ban đầu cho combobox khi combo chưa có dữ liệu
		 * Created by LTDAT(25.06.2020)
		 */
		setInitText() {
			const me = this;
			me.internalText = me.initText;
		},
		/**
		 * Thực hiện query dữ liệu, có thể từ local hoặc remote tùy theo cấu hình
		 * CreatedBy LTDAT 11/12/2019
		 */
		doQueryInternal(searchString, expand = true) {
			let me = this,
				event = { preventDefault: false, sender: me },
				queryString = searchString != null ? searchString : me.getQueryString();
			me.$emit('beforeQuery', event);
			if (event.preventDefault) {
				return false;
			}

			if (me.lastQueryString == queryString) {
				me.expand(expand);
			} else {
				me.lastQueryString = queryString;
				me.querying = true;
				me.typeAheadPointer = -1;
				if (me.queryMode === 'remote') {
					me.doRemoteQuery(queryString).then((x) => {
						commonFunc.genVKeyValue(me.internalDataSource);
						me.afterQuery(expand);
					});
				} else {
					me.doLocalQuery(queryString).then((x) => me.afterQuery(expand));
				}
			}
		},
		/**
		 * Xử lý sau khi query xong dữ liệu
		 * CreatedBy LTDAT 24.06.2020
		 */
		afterQuery(expand) {
			const me = this;
			me.expand(expand);
			me.typeAheadPointer = me.filterIndexItemByText();
		},
		/**
		 * Query dữ liệu api
		 * CreatedBy LTDAT 24.06.2020
		 */
		doRemoteQuery(queryString, expand) {
			//Build filter,
			let me = this,
				filters = [],
				filterFields = me.filterFields;
			return new Promise((resolve, reject) => {
				if (queryString) {
					for (const key in filterFields) {
						if (filterFields.hasOwnProperty(key)) {
							const f = filterFields[key];
							let filter = {
								property: key,
								value: queryString,
								operator: f,
								operand: 'or',
							};
							filters.push(filter);
						}
					}
				}
			});
		},
		/**
		 * Query dữ liệu local
		 * CreatedBy LTDAT 24.06.2020
		 */
		doLocalQuery(queryString) {
			let me = this,
				store = me.store;

			return new Promise((resolve, reject) => {
				//Kiểm xem store đã load dữ liệu chưa, nếu chưa thì load lần đầu
				let p;
				if (me.autoLoad && store && !store._loaded && store.getCount() == 0) {
					let proxy = store.proxy;
					if (proxy && proxy.type === 'cache') {
						p = store.load();
					}
				}
				p ? p.then(resolve, reject) : resolve(false);
			}).then(() => {
				me.loading = false;
			});
		},
		/**
		 * Lấy chuỗi cần query, trường hợp number thì lấy value bỏ qua ký tự phân cách
		 * CreatedBy LTDAT 11/12/2019
		 */
		getQueryString() {
			return (this.internalText || '').trim();
		},
		//Click ra ngoài combo đóng combo lại
		//Created by LTDAT 18.06.2020
		click_out(e) {
			const me = this;
			if (
				!commonFunc.hasParent(e.target, me.$el) &&
				!commonFunc.hasParent(e.target, me.$refs.dropdownPanel.$el)
			) {
				me.expand(false);
			}
		},
		//Reset lại các giá trị trong combobox
		reset() {
			const me = this;
			me.internalText = '';
			me.internalSelectedItem = null;
			me.typeAheadPointer = -1;
			me.internalValue = null;
			me.$emit('input', me.internalValue);
		},
		/**
		 * Set giá trị hiển thị
		 * @pram value giá trị hiển thị
		 */
		setInternalText(value) {
			const me = this;
			me.internalText = value;
		},

		/**
		 * Set value cho combo
		 */
		setValue(value) {
			const me = this;
			me.internalValue = value;
			me.$emit('input', me.internalValue);
			me.doHightlightItem();
			if (me.typeAheadPointer >= 0) {
				me.setInternalItem(me.internalDataSource[me.typeAheadPointer], false);
			}
		},
		//Sự kiện nhập liệu trên input
		//Created by LTDAT (16.06.2020)
		onInput(e) {
			const me = this;
			if (!me.expanded) {
				me.expand(true);
			}
			if (!me.internalText) {
				if (me.internalValue) {
					let metaData = {
						oldData: me.internalSelectedItem,
						newData: null,
					};
					me.$emit('selected', metaData);
				}
				if (me.internalDataSource && me.internalDataSource.length > 0) {
					me.internalDataSourceFilter = [...me.internalDataSource];
				}
				me.reset();
			} else if (me.internalText) {
				me.typeAheadPointer = me.filterIndexItemByText();
				me.internalDataSourceFilter = [
					...me.internalDataSource.filter((x) => {
						let displayField = x[`${me.displayField}`];
						if (!displayField) return false;

						return displayField
							.toLowerCase()
							.includes(me.internalText.toLowerCase());
					}),
				];
			} else {
				me.typeAheadPointer = me.filterIndexItemByText();
			}
		},
		//Sự kiện focus vào input
		//Created by LTDAT (16.06.2020)
		onFocus(e) {
			const me = this;
			me.focused = true;
		},
		//Sự kiện change input
		//Created by LTDAT (16.06.2020)
		onChange(e) {
			const me = this;
			if (me.focused) {
				if (me.forceSelection) {
					me.typeAheadPointer = me.filterIndexItemByText();
					if (me.typeAheadPointer < 0) {
						me.reset();
					}
					// else{
					//     me.validate(me.internalText);
					// }
				} else {
					if (me.autoMappingValue) {
						me.typeAheadPointer = me.filterIndexItemByText();
						if (me.typeAheadPointer < 0) {
							me.internalValue = me.internalText;
						}
					} else {
						me.internalValue = me.internalText;
					}
					me.$emit('input', me.internalValue);
				}
			}
			me.$emit('change', me.internalValue);
		},
		//Sự kiện blur input
		//Created by LTDAT (16.06.2020)
		onBlur(e) {
			const me = this;
			me.focused = false;
			me.$emit('blur', e);
			// me.validate(me.internalText);
			me.validate(null, me.data, false, {
				displayField: me.displayField,
				valueField: me.valueField,
			});
		},
		//Sự kiện keydown input
		//Created by LTDAT (16.06.2020)
		onKeydown(e) {
			const me = this;
			switch (e.which) {
				case 40:
					{
						if (!me.expanded) {
							me.expand(true);
						} else if (me.typeAheadPointer < me.getTotalData() - 1) {
							if (me.notSelectionParent) {
								let typeAheadPointerNext = me.typeAheadPointer + 1;
								for (let i = typeAheadPointerNext; i < me.getTotalData(); i++) {
									me.typeAheadPointer++;
									me.adjustScroll(typeAheadPointerNext);
									if (!me.internalDataSource[i].isParent) {
										break;
									}
								}
							} else {
								me.typeAheadPointer++;
								me.adjustScroll();
							}
						}
					}
					break;
				case 38:
					{
						if (me.expanded) {
							if (me.typeAheadPointer > 0) {
								if (me.notSelectionParent) {
									let typeAheadPointerPre = me.typeAheadPointer - 1;
									for (let i = typeAheadPointerPre; i > 0; i--) {
										me.typeAheadPointer--;
										me.adjustScroll(me.typeAheadPointer);
										if (!me.internalDataSource[i].isParent) {
											break;
										}
									}
								} else {
									me.typeAheadPointer--;
									me.adjustScroll();
								}
							}
						}
					}
					break;
				case 13:
					{
						event.preventDefault();
						if (me.typeAheadPointer >= 0) {
							me.setInternalItem(
								me.internalDataSourceFilter[me.typeAheadPointer]
							);
							//Bổ sung event change item
							me.$emit('changeItem');
						}
						me.expand(false);
					}
					break;
				case 9:
					{
						if (me.expanded) {
							if (me.typeAheadPointer >= 0) {
								me.setInternalItem(me.internalDataSource[me.typeAheadPointer]);
								me.$emit('changeItem');
							}
							me.expand(false);
						}
					}
					break;
			}
			me.$emit('keydown', event);
		},
		//Lấy tổng số lượng dữ liệu trong data
		getTotalData() {
			const me = this;
			return me.internalDataSource.length;
		},
		//Bôi màu hightlight cho item
		doHightlightItem() {
			const me = this;
			if (me.internalDataSourceFilter) {
				if (me.internalDataSourceFilter.length > 0) {
					if (me.internalValue != null && me.internalValue != undefined) {
						//Trước khi load tính toán lại typeAheadPointer nếu cần thiết để scroll di chuyển về dúng vị trí khi show scroller lên
						//Tìm vị trí selectedItem trong source, không lấy selectedIndex vì có thể không chính xác khi source thay đổi
						let index = _.findIndex(
							me.internalDataSourceFilter,
							(item) => item[me.valueField] === me.internalValue
						);
						me.typeAheadPointer = index;
					} else {
						me.typeAheadPointer = -1;
					}
				}
			}
		},
		//Tìm kiếm item trong list
		//Created by LTDAT(16.06.2020)
		filterIndexItemByText() {
			const me = this;
			let filters = me.filterFields,
				value = me.internalText,
				index = -1;
			if (filters) {
				index = me.internalDataSourceFilter.findIndex((item, _index) => {
					let ret = false;
					for (const key in filters) {
						if (filters.hasOwnProperty(key)) {
							const s = filters[key];
							if (s == 'contains') {
								ret =
									item[key] &&
									item[key].toString() &&
									item[key]
										.toString()
										.toLowerCase()
										.contains(value.toLowerCase());
							} else {
								ret =
									item[key] &&
									item[key].toString() &&
									item[key]
										.toString()
										.toLowerCase()
										.startsWith(value.toLowerCase());
							}
							if (ret) {
								break;
							}
						}
					}
					return ret;
				});
			}
			me.adjustScroll();
			return index;
		},
		//Lấy cột filter để tìm kiếm local
		//Created by LTDAT 16.06.2020
		getFilterFields() {
			let filter = {};

			if (this.columns && this.columns.length > 0) {
				for (let i = 0; i < this.columns.length; i++) {
					const col = this.columns[i];
					if (!col.filterOperator) {
						col.filterOperator = 'contains';
					}
					if (col.dataField && col.filterOperator) {
						if (this.filterColumns && this.filterColumns.length > 0) {
							this.filterColumns.forEach((e) => {
								if (!filter.hasOwnProperty(e)) {
									filter[e] = col.filterOperator;
								}
							});
						} else {
							filter[col.dataField] = col.filterOperator;
						}
					}
				}
			} else {
				filter[this.displayField] = 'contains';
			}
			return filter;
		},
		//Lấy element scroll
		//Created by LTDAT (16.06.2020)
		getScroller() {
			if (this.expanded) {
				return this.$refs['scroller'];
			}
			return null;
		},
		/**
		 * Di chuyển view đến bản ghi nếu cần
		 * @param {Bản ghi cần view} index
		 * CreatedBy LTDAT 16.06.2020
		 */
		adjustScroll(typeAheadPointer = this.typeAheadPointer) {
			let scroller = this.getScroller();
			if (scroller) {
				scroller.scrollToItem(typeAheadPointer, true);
			}
		},
		onScrollerVisible() {
			const me = this;
			me.adjustScroll();
		},
		//Hàm xử lý khi chọn item trên dropdown
		//Created by LTDAT(16.06.2020)
		onItemClick(item, event) {
			const me = this;
			// Không sử lý event click với trường hợp này
			// Chỉ phục vụ sử lý trường hợp custom combobox Org dạng cây: hiển thị tên chi  nhánh với email
			if (!item || (me.isCustomComboxOrg && !item.InvRevEmail)) return;

			//Bổ sung event change item
			//Bổ sung để không set dữ liệu combobox trên daterange dashboard - khi lựa chọn tùy chọn khác
			//Cho phép set item hay không
			let allowSetItem = !(
				me.unAllowSetItemClick &&
				item &&
				item.value == me.$ms.enum.Period.Other
			);
			if (allowSetItem) {
				me.setInternalItem(item);
			} else {
				me.expand(false);
			}
			me.$emit('changeItem', allowSetItem);
			me.$refs.input.focus();
		},
		//Set giá trị được chọn
		setInternalItem(item, userAction = true) {
			const me = this;
			if (item) {
				if (me.notSelectionParent && item.isParent) {
					return;
				}
				let metaData = {
					oldData: me.internalSelectedItem,
					newData: item,
				};
				me.internalSelectedItemBefore = me.internalSelectedItem;
				me.internalSelectedItem = item;
				me.internalValue = item[me.valueField];
				me.$emit('input', me.internalValue);
				me.internalText = item[me.displayField];
				me.typeAheadPointer = me.findIndexItem(item);
				me.expand(false);
				me.$emit('update:display', me.internalText);
				if (me.mappingField) {
					for (let key in me.mappingField) {
						let emitStrUpdate = 'update:' + key;
						me.$emit(
							emitStrUpdate,
							me.internalSelectedItem[me.mappingField[key]]
						);
					}
				}
				if (userAction == true) {
					me.$emit('selected', metaData);
				}
			}
		},
		//Tìm vị trị của item trong data
		findIndexItem(item) {
			const me = this;
			return me.internalDataSource.findIndex((_item) => {
				return _item == item;
			});
		},
		//Khởi tạo dữ liệu tĩnh mặc định
		initStaticData() {
			const me = this;
			me.comboType = 1;

			me.internalQueryDelay = 200;
			me.filterFields = me.getFilterFields();
			me.internalValue = null;
			me.firstExpand = true;
		},
		//Khởi tạo dữ liệu
		initData() {
			const me = this;
			if (me.store) {
				me.internalDataSource = me.store.data.items;
				me.internalDataSourceFilter = me.store.data.items;
			} else {
				me.internalDataSource = me.data;
				me.internalDataSourceFilter = me.data;
			}
			commonFunc.genVKeyValue(me.internalDataSource);
		},
		/**
		 * Khởi tạo combo
		 *
		 * @author hngiap - 01.09.2019
		 * 1 là combo không có columns (ComboEditor)
		 * 2 là combo có columns
		 * 3 là combo tree
		 */
		initCombo() {
			const me = this;
			if (me.isComboTree) {
				me.comboType = 3;
			} else if (me.columns && me.columns.length !== 0) {
				me.comboType = 2;
			} else {
				me.comboType = 1;
			}
		},
		//Đóng mở combobox
		async expand(mode = !this.expanded) {
			const me = this;
			if (me.firstExpand && mode) {
				if ((me.queryMode == 'remote' && !me.autoLoad) || me.firstExpandLoad) {
					me.doQueryInternal(null, true);
					if (me.isLoadAllData) {
						await commonFunc.emitPromise(me, 'loadAllData');
					}
				}
				me.firstExpand = false;
			}
			if (mode == true) {
				me.$emit('beforeExpand');
				document.addEventListener('mousedown', me.click_out);
				me.$refs.input.focus();
				me.changeDropdownPosition();
			} else {
				document.removeEventListener('mousedown', me.click_out);
				me.internalDataSourceFilter = [...me.internalDataSource];
			}
			me.expanded = mode;
			me.doHightlightItem();
		},
		/**
		 * Hàm set vị trí cho dropdown menu khi expand
		 * TODO: Chưa xử lý khi có scroll
		 */
		changeDropdownPosition() {
			let me = this,
				comboEl = me.$el,
				comboElRect = comboEl.getBoundingClientRect(),
				comboMenuEl = me.$el;

			let windowWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;

			let windowHeight =
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight;

			me.dropdownLeftx = comboElRect.left;
			me.dropdownTopx = comboElRect.top + comboElRect.height + 2;
			me.dropdownMaxWidthx = me.dropdownMinWidthx = me.dropdownWidth
				? me.dropdownWidth
				: comboElRect.width;

			// Nếu chạm phải thì align sang trái
			if (comboElRect.left + comboMenuEl.offsetWidth > windowWidth) {
				me.dropdownLeftx = comboElRect.right - comboMenuEl.offsetWidth;
			}

			// Nếu chạm bottom thì align top
			let maxItemsDisplay = me.maxItemsDisplay;
			if (me.columns && me.columns.length > 0) {
				maxItemsDisplay += 1;
			}
			if (
				comboElRect.bottom + me.itemSize * maxItemsDisplay + 2 >
				windowHeight
			) {
				me.dropdownTopx =
					comboElRect.top -
					(me.itemSize *
						Math.min(maxItemsDisplay, me.internalDataSource.length) +
						4);
			}
		},
	},
	watch: {
		rules: {
			handler(newVal, oldVal) {
				const me = this;
				let data = {
					internalDataSource: me.internalDataSource,
				};
				me.validate(null, null, false, {
					displayField: me.displayField,
					valueField: me.valueField,
				});
			},
		},
		data: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				if (me.internalDataSource != newVal) {
					me.initData();
				}
				me.$nextTick(() => {
					me.doHightlightItem();
					if (
						me.initIndex >= 0 &&
						me.internalDataSource[me.initIndex] &&
						me.typeAheadPointer < 0
					) {
						me.typeAheadPointer = me.initIndex;
					}
					if (me.typeAheadPointer >= 0) {
						me.setInternalItem(
							me.internalDataSource[me.typeAheadPointer],
							false
						);
					}
				});
			},
		},
		/**
		 * Set lại giá trị hiển thị khi giá trị của biến initText thay đổi
		 */
		initText: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				if (newVal || oldVal) {
					me.setInitText(newVal);
				}
			},
		},
		/**
		 * Kiểm tra nếu text hiện thị thay đổi thi validate
		 */
		internalText: {
			handler(newVal, oldVal) {
				const me = this;
				newVal = newVal ? newVal : '';
				oldVal = oldVal ? oldVal : '';
				if (newVal != oldVal) {
					//nvnam3: validate thêm trường hợp muốn kiểm tra text có trong danh sách combobox hay không
					let data = me.internalDataSource;
					me.validate(newVal, data, false, {
						displayField: me.displayField,
						valueField: me.valueField,
					});
				}
				me.$emit('changeText', newVal);
				// me.$emit('input',newVal);
			},
		},
		/**
		 * Nếu giá trị VModel của combo thay đổi thì gán lại giá trị mới và select vào item tương ứng có trong data
		 */
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				const me = this;
				if (newVal != null && newVal != undefined) {
					me.internalValue = newVal;
					if (
						!me.internalSelectedItem ||
						me.internalSelectedItem[me.valueField] !== newVal
					) {
						if (me.internalDataSource != me.data) {
							me.initData();
						}
						me.doHightlightItem();
						if (me.typeAheadPointer >= 0) {
							me.setInternalItem(
								me.internalDataSource[me.typeAheadPointer],
								false
							);
						} else {
							if (!me.forceSelection && me.valueField == me.displayField) {
								me.setInternalText(me.internalValue);
							}
						}
					}
				} else {
					me.reset();
				}
			},
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/msCombo.scss';
}
@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/msCombo.scss';
}
.combobox-dropdown-custom {
	padding: 10px;
}
.ms-combobox-item-custom {
	margin-bottom: 10px;
	display: flex;
	align-items: center;
}
</style>
